// SearchInput component translations
export default {
  // Tab titles
  tabs: {
    canvasAnalysis: "Canvas Analysis",
    dataDetail: "Data Details",
    aiAssessment: "AI Assessment",
  },

  // Placeholder texts
  placeholders: {
    multiCurrency: "Search address / hash / investigation user ID",
    singleCurrency: "Search address / hash",
  },

  // Canvas type options
  canvasTypes: {
    multi: "Multi-Currency Canvas",
    single: "Single-Currency Canvas",
  },

  // Buttons and actions
  actions: {
    search: "Search",
    clear: "Clear",
    exampleData: "Example Data",
  },

  // Messages
  messages: {
    noAddress: "No address found",
    singleCurrencyUserNotSupported:
      "Single-currency canvas does not support investigation user queries",
    userFunctionRestricted:
      "This function is only available for professional users, please contact customer service for consultation.",
  },

  // History
  history: {
    loading: "Loading...",
    noHistory: "No history records",
  },
};
